import AjaxRequestManager from '@/js/common/Domain/AjaxRequestManager';

const ajaxRequestManager = new AjaxRequestManager();

const readErrorMessage = (response) => {
    const message = response?.clientMessage;

    if (typeof message !== 'string') {
        return null;
    }

    const trimmed = message.trim();

    return trimmed === '' ? null : trimmed;
};

export default function hotelOfferRedirectService(identity, callbacks) {
    if (!identity) {
        console.log('no identity');
        return;
    }

    const options = {
        url: '/order/createQuote',
        type: 'post',
        data: {
            identity,
            type: 'HotelOfferProduct',
        },
        retriesAvailable: 1,
    };

    ajaxRequestManager.getData(options, {
        success: (data, response) => {
            if (response.success && response.data && response.uuid) {
                callbacks.success(response.data);
            } else {
                callbacks.error(readErrorMessage(response), response);
            }
        },
        error: (data, response) => {
            callbacks.error(readErrorMessage(response), response);
        },
    });
}
